import { connect } from 'react-redux';
import { 
    togglePushMessagesModal,
    getAdminMessages,
    getSystemMessages,
    getScheduledMessages,
    toggleFilterSettingsModal,
} from "../../redux/pushMessages/actions";
import { sendErrorLog } from '../../redux/logging/actions';
import { PushMessages } from './PushMessages';
import { getUserByPnr } from '../../redux/users/actions';

const mapStateToProps = (state) => ({
  currentBloodbank: state.authReducer.currentBloodbank,
  adminMessages: state.pushMessagesReducer.adminMessages,
  systemMessages: state.pushMessagesReducer.systemMessages,
  scheduledMessages: state.pushMessagesReducer.scheduledMessages,
  selectedFilters: state.pushMessagesReducer.selectedFilters,
  userRoleName: state.authReducer.roleName,
  userByPnr: state.usersReducer.userByPnr,
});

const mapDispatchToProps = {
    togglePushMessagesModal,
    getAdminMessages,
    getSystemMessages,
    getScheduledMessages,
    toggleFilterSettingsModal,
    sendErrorLog,
    getUserByPnr,
};

export default connect(mapStateToProps, mapDispatchToProps)(PushMessages);